<h2 mat-dialog-title>Continuous Auto Buy</h2>

<mat-dialog-content>
  @if (loading) {
  <div class="loading-state"><mat-spinner diameter="40"></mat-spinner></div>
  } @else {
  <form [formGroup]="form" class="auto-buy-form">
    <p class="hint-text">
      Bot-driven stock accounts buy listed cards continuously. Changes apply to future leases; turning it off
      releases running leases and all locked allocations.
    </p>

    @if (config) {
    <div class="status-row">
      <span>Active leases: <strong>{{ config.active_leases }}</strong></span>
      @if (config.buy_contract_id) {
      <button mat-button type="button" (click)="viewLeases()">
        <mat-icon>precision_manufacturing</mat-icon>
        Stock Leases
      </button>
      }
    </div>
    }

    <mat-slide-toggle formControlName="is_active" color="primary">
      {{ form.controls.is_active.value ? 'Running' : 'Stopped' }}
    </mat-slide-toggle>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Concurrent Stocks</mat-label>
      <input matInput type="number" formControlName="desired_concurrent_stocks" min="1" max="100">
      <mat-icon matPrefix>speed</mat-icon>
      <mat-hint>Maximum stocks buying at once (1–100).</mat-hint>
      @if (form.controls.desired_concurrent_stocks.invalid) {
      <mat-error>Must be between 1 and 100</mat-error>
      }
    </mat-form-field>

    <div class="toggle-row">
      <span class="toggle-label">Suppliers:</span>
      <mat-button-toggle-group formControlName="supplier_scope" aria-label="Supplier scope">
        <mat-button-toggle value="all">All</mat-button-toggle>
        <mat-button-toggle value="selected">Selected</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @if (isSelectedScope) {
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Suppliers</mat-label>
      <mat-select formControlName="supplier_ids" multiple>
        @for (s of suppliers; track s.user_id) {
        <mat-option [value]="s.user_id">{{ s.name }}</mat-option>
        }
        @for (id of form.controls.supplier_ids.value; track id) {
        @if (!suppliers.length) {
        <mat-option [value]="id">{{ supplierName(id) }}</mat-option>
        }
        }
      </mat-select>
      <mat-icon matPrefix>store</mat-icon>
      <mat-hint>Only enabled suppliers can be selected; at least one is required.</mat-hint>
    </mat-form-field>
    }
  </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!canSave">
    @if (saving) {
    <mat-spinner diameter="20"></mat-spinner>
    } @else {
    Save
    }
  </button>
</mat-dialog-actions>
